import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RouterModule } from '@angular/router';
import { SidenavComponent } from './sidenav/sidenav.component';
import { PortalModule } from '@angular/cdk/portal';

const modules = [
  CommonModule,
  RouterModule,
  ClipboardModule,
  ReactiveFormsModule,
  MaterialModule,
  PortalModule,
];
const components = [
  ToolbarComponent,
  SidenavComponent,
];

@NgModule({
  declarations: components,
  imports: modules,
  exports: [...modules, ...components]
})
export class SharedModule {
}
